<template>
    <div>
        <allProduct :genre="3" :classId="2" :good_type="1"></allProduct>
    </div>
</template>

<script>
import allProduct from "@/components/allProduct"
export default {
    components: { allProduct },
    name: '',
    data() {
        return {}
    },
    methods: {
    },
}

</script>
<style scoped></style>